import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import County from "../County";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class CountyBase
 * @extends ModelBaseClass
 * @property {number} id (int64)
 * @property {string} name
 */
class CountyBase extends ModelBaseClass {
	/**
	 * @type {number} id (int64)
	 */
	id;
	/**
	 * @type {string} name
	 */
	name;

	/**
	 * Instantiates a new instance of County based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {County}
	 */
	static create(genericObject) {
		const newCounty = new County();
		newCounty.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCounty;
	}

	/**
	 * Instantiates a new array of County based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[County]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCountyArray = [];
		genericArray.forEach(genericObject => {
			newCountyArray.push(County.create(genericObject));
		});
		return newCountyArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('id', 'integer'),
	ModelBaseClass.createModelProperty('name', 'string'),
];

export default CountyBase;
